<template>
  <path
    d="M21 4.45018C21 3.65018 20.35 3.00018 19.55 3.00018H4.45C3.65 3.00018 3 3.65018 3 4.45018C3 4.80018 3.13 5.15018 3.37 5.41018L11 14.0002V19.0002H7C6.45 19.0002 6 19.4502 6 20.0002C6 20.5502 6.45 21.0002 7 21.0002H17C17.55 21.0002 18 20.5502 18 20.0002C18 19.4502 17.55 19.0002 17 19.0002H13V14.0002L20.63 5.41018C20.87 5.15018 21 4.80018 21 4.45018ZM7.43 7.00018L5.66 5.00018H18.35L16.57 7.00018H7.43Z"
  />
</template>
